import React, {useMemo} from 'react'
import {useTranslation} from '@lib/intl/useTranslations'
import WizNavTabs from '@component/tabs/WizNavTabs'
import HelpCenterText from '@component/Text/HelpCenterText'

export type LeaderboardTab = 'main' | 'copyleader' | 'league' | 'league-all'

interface Props {
    activeTab?: LeaderboardTab
    onChangeActiveTab?: (activeTab: LeaderboardTab) => void
}

const LeaderboardTabNavigation = ({activeTab, onChangeActiveTab}: Props) => {
    const t = useTranslation()

    const TABS: {id: LeaderboardTab[]; label: string; link: string}[] = useMemo(
        () => [
            {id: ['main'], label: t('newLeaderboard.layout.nav.menu.mainLeaderboard'), link: '/leaderboard'},
            {
                id: ['copyleader'],
                label: t('newLeaderboard.layout.nav.menu.copyLeader'),
                link: '/leaderboard?tab=copyleader',
            },
            {
                id: ['league', 'league-all'],
                label: t('newLeaderboard.layout.nav.menu.league'),
                link: '/leaderboard?tab=league',
            },
        ],
        [t],
    )

    return (
        <div className={'relative flex items-center justify-center'}>
            <WizNavTabs
                className={'relative mb-[20px] sm:mb-[15px] sm:w-full'}
                buttonClassName={'sm:px-[10px]'}
                tabs={TABS}
                selectedTab={activeTab}
                setSelectedTab={onChangeActiveTab}
            />
            <HelpCenterText className={'absolute right-0 sm:hidden translate-y-[-50%]'} />
        </div>
    )
}

export default React.memo(LeaderboardTabNavigation)
